import React, { forwardRef } from 'react'
import { useValidatedValueAmountTextInput } from '@/hooks'

interface AmountTextInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  currencyCode?: string
  shouldMaskStablecoinAsFiat?: boolean
  prefix?: string
  prefixFontSize?: number
  onChangeText?: (value: string) => void
}

export const AmountTextInput = forwardRef<
  HTMLInputElement,
  AmountTextInputProps
>(
  (
    {
      currencyCode,
      shouldMaskStablecoinAsFiat = false,
      prefix,
      prefixFontSize,
      onChangeText,
      onChange,
      value = '0',
      maxLength,
      style,
      ...props
    },
    ref,
  ) => {
    const { validatedValue, onValidateAmountTextInput } =
      useValidatedValueAmountTextInput({
        value: String(value),
        currencyCode,
        onChangeText,
        shouldMaskStablecoinAsFiat,
        maxLength,
      })

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const inputValue = e.target.value

      // Применяем валидацию к введенному значению
      const validatedInput = onValidateAmountTextInput(inputValue)

      if (validatedInput === undefined) {
        // Блокируем ввод если валидация не прошла
        return
      }

      // Создаем новый event с валидированным значением
      const cleanEvent = {
        ...e,
        target: { ...e.target, value: validatedInput },
      }

      onChange?.(cleanEvent)
    }

    const isEmpty = validatedValue.length === 0 || validatedValue === '0'
    const inputStyle = style as React.CSSProperties

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-end',
          width: '100%',
        }}
      >
        {prefix && (
          <span
            style={{
              fontSize: prefixFontSize || inputStyle?.fontSize || 28,
              fontWeight: inputStyle?.fontWeight || 600,
              color: inputStyle?.color || '#fff',
              lineHeight: inputStyle?.lineHeight || 1,
              paddingBottom: inputStyle?.paddingBottom || 2,
            }}
          >
            {prefix}
          </span>
        )}
        <input
          ref={ref}
          type="text"
          inputMode="decimal"
          value={validatedValue}
          onChange={handleChange}
          placeholder={isEmpty ? '0' : ''}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            outline: 'none',
            fontSize: 28,
            fontWeight: 600,
            width: '100%',
            flex: 1,
            WebkitAppearance: 'none',
            MozAppearance: 'textfield',
            ...style,
          }}
          {...props}
        />
      </div>
    )
  },
)

AmountTextInput.displayName = 'AmountTextInput'
